import service from './axios';
export const getAttractions = (params = {}) => service.get('/manage/attractions', { params });
export const getAttraction = (id) => service.get(`/manage/attractions/${id}`);
export const createAttraction = (d) => service.post('/manage/attractions', d);
export const updateAttraction = (id, d) => service.put(`/manage/attractions/${id}`, d);
export const deleteAttraction = (id) => service.delete(`/manage/attractions/${id}`);
